module.exports = __webpack_public_path__ + "static/media/26.781e665d.jpg";